const ptBrCommonFieldsTranslations = {
  createdAt: "Data de criação",
  updatedAt: "Data da última atualização",
};

export { ptBrCommonFieldsTranslations };

export const tenant = {
  not_found: "Tenant não encontrado",
};

export const forbidden = {
  title: "Acesso negado",
  message:
    "Você não tem permissão para acessar nenhum recurso. Entre em contato com o administrador.",
};

export const auth = {
  invalidCreds: "Credenciais inválidas",
};

export const common = {
  fields: {
    ...ptBrCommonFieldsTranslations,
  },
  audit: {
    button: "Auditoria",
    title: "Histórico de Auditoria",
    close: "Fechar",
    details: "Detalhes da Auditoria",
    dateTime: "Data e Hora",
    user: "Usuário",
    action: "Ação",
    changes: "Alterações Realizadas",
    additionalInfo: "Informações Adicionais",
    noChanges: "Nenhuma alteração de campo registrada para esta ação.",
    before: "Antes",
    after: "Depois",
    yes: "Sim",
    no: "Não",
    relatedResource: "Recurso Relacionado",
    relatedChange: "Mudança Relacionada",
    metadata: {
      ip: "Endereço IP",
      userAgent: "Navegador",
      userName: "Nome do Usuário",
      userEmail: "E-mail do Usuário",
      changedBy: "Alterado por",
      changedForUserId: "Alterado para Usuário",
      passwordChanged: "Senha Alterada",
      statusChanged: "Mudança de Status",
    },
  },
};

export const menu = {
  hr: "Recursos Humanos",
  registrations: "Cadastros",
  bi: "Business Intelligence",
  chat: "Atendimento",
};

export const citySearch = {
  label: "Cidade",
  placeholder: "Digite para buscar uma cidade...",
  minChars: "Digite pelo menos 1 caractere para buscar",
  noResults: "Nenhuma cidade encontrada",
};

export const validation = {
  phone: {
    invalid: "Número de telefone inválido",
  },
};

export const schedule = {
  timezone: "Fuso Horário",
  start: "Início",
  end: "Fim",
  days: {
    sunday: "Domingo",
    monday: "Segunda",
    tuesday: "Terça",
    wednesday: "Quarta",
    thursday: "Quinta",
    friday: "Sexta",
    saturday: "Sábado",
  },
};

export const hr = {
  fields: {
    name: "Nome",
    role: "Cargo",
    requester: "Solicitante",
    openDate: "Data de Abertura",
    closeDate: "Data de Fechamento",
    resumeSource: "Fonte do Currículo",
    campaign: "Campanha",
    price: "Preço",
    candidateName: "Nome do Candidato",
    email: "E-mail",
    phone: "Telefone",
    resumeUrl: "Link do Currículo",
    status: "Status",
    interviewDate: "Data da Entrevista",
    notes: "Observações",
  },
  status: {
    CREATED: "Criado",
    CONNECTED: "Conectado",
    SCHEDULED: "Agendado",
    INTERVIEWED: "Entrevistado",
    HIRED: "Contratado",
  },
  behavioralProfile: {
    ANALYTICAL: "Analítico",
    DRIVER: "Condutor",
    AMIABLE: "Amigável",
    EXPRESSIVE: "Expressivo",
  },
};
